import React, { Component } from 'react';
import Question from '../question/question';
import image from '../../assets/images/tta/values-background.jpg';
import octagon from '../../assets/icons/shape.svg';
import octagonMobile from '../../assets/icons/shape-thick.svg';
import greyOctagon from '../../assets/icons/grey_polygon.svg';
import greyOctagonMobile from '../../assets/icons/polygon-thick-border-grey.svg';
import circle from '../../assets/icons/circle-border.svg';
import semiCircle from '../../assets/icons/semi-circle-white.svg';

class OurValues extends Component {
	state = {
		activeQuestion: -1
	};

	handleQuestion(question) {
		const { activeQuestion } = this.state;

		if (question === activeQuestion) {
			this.setState({ activeQuestion: -1 });
		} else {
			this.setState({ activeQuestion: question });
		}
	}

	render() {
		const { activeQuestion } = this.state;
		const { title, description, questions } = this.props.data;
		return (
			<section id="our-values">
				<div className="container container-fluid">
					<div className="row between-md">
						<div className="questions col-xs-12 col-md-5">
							<h3>{title}</h3>
							<p>{description}</p>
							<div>
								{questions.map((question, index) => (
									<Question
										key={question.value.question}
										question={question.value.question}
										answer={question.value.answer}
										index={index}
										activeQuestion={activeQuestion}
										handleQuestion={() => this.handleQuestion(index)}
									/>
								))}
							</div>
						</div>
						<div className="image col-xs-12 col-md-6">
							<div className="image-container">
								<img src={image} alt="" />
							</div>
						</div>
					</div>
					<img src={greyOctagon} className="grey-octagon desktop" alt="" />
					<img src={greyOctagonMobile} className="grey-octagon mobile" alt="" />
					<img src={octagon} className="octagon desktop" alt="" />
					<img src={octagonMobile} className="octagon mobile" alt="" />
					<img src={circle} className="circle" alt="" />
					<img src={semiCircle} className="semi-circle" alt="" />
				</div>
			</section>
		);
	}
}

export default OurValues;
